import CrudApiClient from './crudapiclient';
import { axiosInstance } from './axios';
import { GATEWAY_API_URL } from '@admin-panel/config/env';

class CouponApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/coupon');
  }

  // Get usage count for a coupon
  async getUsageCount(couponId: number) {
    return axiosInstance.get(`${GATEWAY_API_URL}/coupon-usage/count/coupon/${couponId}`);
  }
}

export default CouponApiClient;
